export default __webpack_public_path__ + "static/media/Path 6.4511a6aa.svg";